module.exports = __webpack_public_path__ + "0fc25386220a58203994ce45fb4ae570.ttf";